'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _languages;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _Language = require('@material-ui/icons/Language');
var _Language2 = _interopRequireDefault(_Language);
var _MenuItem = require('@material-ui/core/MenuItem');
var _MenuItem2 = _interopRequireDefault(_MenuItem);
var _reactI18next = require('react-i18next');
var _reactRouter = require('react-router');
var _DropdownMenu = require('../components/DropdownMenu');
var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var ENGLISH = 'en',
  SPANISH = 'es',
  FRENCH = 'fr',
  GERMAN = 'de',
  ITALIAN = 'it',
  PORTUGUESE = 'pt',
  CATALAN = 'ca',
  DUTCH = 'nl',
  ARABIC = 'ar',
  VIETNAMESE = 'vi',
  SIMPLIFIED_CHINESE = 'zh',
  TRADITIONAL_CHINESE = 'zh-TW',
  KOREAN = 'ko',
  JAPANESE = 'ja';
var languages = (_languages = {}, _defineProperty(_languages, ENGLISH, {
  locale: ENGLISH,
  name: 'English'
}), _defineProperty(_languages, SPANISH, {
  locale: SPANISH,
  name: 'Español'
}), _defineProperty(_languages, FRENCH, {
  locale: FRENCH,
  name: 'Français'
}), _defineProperty(_languages, GERMAN, {
  locale: GERMAN,
  name: 'Deutsch'
}), _defineProperty(_languages, ITALIAN, {
  locale: ITALIAN,
  name: 'Italiano'
}), _defineProperty(_languages, PORTUGUESE, {
  locale: PORTUGUESE,
  name: 'Português'
}), _defineProperty(_languages, CATALAN, {
  locale: CATALAN,
  name: 'Català'
}), _defineProperty(_languages, DUTCH, {
  locale: DUTCH,
  name: 'Nederlands'
}), _defineProperty(_languages, ARABIC, {
  locale: ARABIC,
  name: 'اَلْعَرَبِيَّةُ'
}), _defineProperty(_languages, VIETNAMESE, {
  locale: VIETNAMESE,
  name: 'tiếng Việt'
}), _defineProperty(_languages, SIMPLIFIED_CHINESE, {
  locale: SIMPLIFIED_CHINESE,
  name: '中文（简体）'
}), _defineProperty(_languages, TRADITIONAL_CHINESE, {
  locale: TRADITIONAL_CHINESE,
  name: '中文（繁體）'
}), _defineProperty(_languages, KOREAN, {
  locale: KOREAN,
  name: '한국어'
}), _defineProperty(_languages, JAPANESE, {
  locale: JAPANESE,
  name: '日本語'
}), _languages);
var LanguagesMenu = function LanguagesMenu(_ref) {
  var availableLanguages = _ref.availableLanguages,
    pathname = _ref.location.pathname,
    i18n = _ref.i18n;
  return _react2.default.createElement(_DropdownMenu2.default, {
    menuId: 'lang',
    icon: _react2.default.createElement(_Language2.default, null),
    menuItems: Object.keys(languages).filter(function (k) {
      return availableLanguages.includes(k);
    }).map(function (k) {
      return languages[k];
    }).map(function (_ref2) {
      var locale = _ref2.locale,
        name = _ref2.name;
      return _react2.default.createElement(_MenuItem2.default, {
        key: locale,
        component: 'a',
        href: ['', locale].concat(_toConsumableArray(pathname.split('/').slice(2))).join('/'),
        selected: locale === i18n.language
      }, name);
    })
  });
};
exports.default = (0, _reactRouter.withRouter)((0, _reactI18next.translate)()(LanguagesMenu));